// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__13xEB","emptyContainer":"styles_emptyContainer__3Qc1r","placeIcon":"styles_placeIcon__3gica"};